<template>
  <div class="systemManagement" style="height: 100%;">
    <keep-alive :include="cachedViews">
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'systemManagement',
  data() {
    return {};
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
    ...mapGetters({
      cachedViews: 'tags/cachedViews'
    })
  }
};
</script>
<style lang="scss" scoped>
.center {
  text-align: center;
}

.pagination-box {
  padding: 10px 0px;
  text-align: center;
}

.systemManagement {
  width: 100%;
  height: 100%;
  // height: calc(100% - 40px) !important;
  overflow: auto;
  box-sizing: border-box;

  .table-list {
    margin: 0;

    .cell {
      text-align: center;
      white-space: normal !important;
    }

    // height: auto !important;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
    height: 100%;

    .el-scrollbar__view {
      height: 100%;
    }
  }

  & > .el-scrollbar > .el-scrollbar__bar.is-vertical {
    width: 0 !important;
  }
}

</style>
